import React from 'react';
import { Box } from '@kareo/design-system';
var TelehealthLogo = function () {
    return (React.createElement(Box, { width: "100%" },
        React.createElement("img", { src: "https://ui-cdn.patientpop.com/assets/img/tebra-brand/tebra-logo.png", alt: "Tebra Telehealth" })));
};
export default TelehealthLogo;
